import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map} from "rxjs/operators";
import {DeleteSharedLinkService} from "../services/delete-shared-link.service";
import {DELETE_SHARED_LINK_ACTION, DeleteSharedLinkAction} from "../actions/delete-shared-link-actions";
import {NotificationService} from "@alfresco/adf-core";
// @ts-ignore
import {AppStore, ReloadDocumentListAction} from '@alfresco/aca-shared/store';
import {Store} from '@ngrx/store';

@Injectable()
export class DeleteSharedLinkEffects {

  protected store = inject<Store<AppStore>>(Store<AppStore>);

  constructor(private actions$: Actions,
              private deleteSharedLinkService: DeleteSharedLinkService,
              private notificationService: NotificationService) {  }

  deleteSharedLink$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<DeleteSharedLinkAction>(DELETE_SHARED_LINK_ACTION),
        map((action) => {
          if (action.payload) {
            this.deleteSharedLinkService.deleteSharedLink(action.payload).subscribe(() => {
                if (window.location.href.includes('shared')) {
                    let nodeElement = document.getElementsByClassName('adf-datatable-row');
                        for (let i = 0; i < nodeElement.length; i++) {
                            let node = nodeElement[i];
                            let nodeData = node.ariaLabel;
                            if (nodeData && nodeData.includes(action.payload.name)) {
                                node.setAttribute('style', 'opacity: 0.5');
                            }
                        }
                } else {
                    this.store.dispatch(new ReloadDocumentListAction());
                }
                this.notificationService.openSnackMessage('Le lien de partage a bien été supprimé', 4000);
                },
              () => {
                this.notificationService.showError('Une erreur est survenue lors de la suppression du lien de partage');
            });
          }
        })
      ),
      { dispatch: false }
  );

}
